import { ChangeDetectorRef, Component } from "@angular/core";
import { PanelService } from "@sharedV11/services/panel/panel.service";
import { SuperClassComponent } from "@sharedV11/super-class-edit/super-class/super-class.component";
import { EditSchemaComponent } from "./edit-schema/edit-schema.component";

@Component({
  selector: "app-schemas",
  templateUrl: "./schemas.component.html",
  styleUrls: ["./schemas.component.scss"],
})
export class SchemasComponent extends SuperClassComponent {
  constructor(
    protected panelService: PanelService,
    protected cdRef: ChangeDetectorRef
  ) {
    super(panelService, cdRef);
  }
  openPanel() {
    this.customanpanel = EditSchemaComponent;
    this.editChangeCss();
    this.cdRef.detectChanges();
  }
}
